module.exports = __webpack_public_path__ + "static/media/camarao-rosa.6dc59dc4.jpg";